import * as React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface AppIconWithBackgroundProps {
  size: number;
  bgColor: string;
  bgOpacity?: number;
  iconColor: string;
  hoverBgColor?: string;
  hoverBgOpacity?: number;
  hoverIconColor?: string;
  children: React.ReactElement;
}

const AppIconWithBackground: React.FC<AppIconWithBackgroundProps> = ({
  size,
  bgColor,
  bgOpacity = 1,
  iconColor,
  hoverBgColor,
  hoverBgOpacity = 1,
  hoverIconColor,
  children,
}) => {
  const iconSize = 22;
  const borderRadius = size >= 32 ? 8 : 4;

  return (
    <Box
      sx={{
        position: 'relative',
        width: iconSize,
        height: iconSize,
        ...flex.center,
      }}>
      <Box
        sx={{
          position: 'absolute',
          width: size,
          height: size,
          backgroundColor: bgColor,
          opacity: bgOpacity,
          borderRadius: `${borderRadius}px`,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          transition: 'background-color 0.2s, opacity 0.2s',
          '.app-item-container:hover &': hoverBgColor
            ? {
                backgroundColor: hoverBgColor,
                opacity: hoverBgOpacity,
              }
            : {},
        }}
      />
      <Box
        sx={{
          position: 'relative',
          ...flex.center,
          width: iconSize,
          height: iconSize,
          transition: 'color 0.2s',
          svg: {
            width: iconSize,
            height: iconSize,
            display: 'block',
            path: {
              fill: iconColor,
              transition: 'fill 0.2s',
            },
          },
          '.app-item-container:hover &': hoverIconColor
            ? {
                svg: {
                  path: {
                    fill: `${hoverIconColor} !important`,
                  },
                },
              }
            : {},
        }}>
        {children}
      </Box>
    </Box>
  );
};
export default AppIconWithBackground;
